import React from 'react';
import { useQuery, Loading, Error, CheckboxGroupInput , required } from 'react-admin';

const TitleCheckField = ({props}) =>{
 
    let titles =  [];
    var source = props && props.source? props.source : 'roles'
    var label = props && props.label ? props.label : 'Title/Role'
    
    if(props.record && !props.record.roles) { props.record.roles = []; }

    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'usertitles',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'title', order: 'ASC' }
        }
    });
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    titles = data;
    console.log(data)
    return (
        <CheckboxGroupInput  source={source}    label={label} choices={titles}/>
        )
}

export default TitleCheckField